import React, { FC, useReducer } from 'react';

import {
  KafkaOutgoingMessagesPagination,
  KafkaOutgoingMessagesFilters,
} from '@go-shared/types/kafkaLogs';
import { Input, Button } from '@spark-labs/avocado-ui';
// tslint:disable-next-line
import { NativeDatePicker } from '@go-client/components/UIkit/forms/NativeDatePicker/NativeDatePicker';
import { isoDate } from '@go-shared/lib/time';

interface KafkaOutgoingMessagesHeaderProps {
  onFiltersChange: (filters: KafkaOutgoingMessagesFilters) => void;
  paginationConfig?: KafkaOutgoingMessagesPagination;
}

const initialFilters: KafkaOutgoingMessagesFilters = {
  id: undefined,
  sailing: undefined,
  fromDate: undefined,
  toDate: undefined,
  topic: undefined,
  name: undefined,
};

const reducer = (prevState: any, { field, value }: any) => {
  return { ...prevState, [field]: value };
};
export const KafkaOutgoingMessagesHeader: FC<KafkaOutgoingMessagesHeaderProps> = ({
  onFiltersChange,
}) => {
  const [filters, dispatch] = useReducer(reducer, initialFilters);

  function updateFilter<K extends keyof KafkaOutgoingMessagesFilters>(key: K, value: string) {
    dispatch({ field: key, value });
  }
  return (
    <div
      className="h-full px-2 inline-flex items-end pb-5
                w-full overflow-x-hidden"
    >
      <span className="mr-8 input-bar" style={{ width: 300 }}>
        <Input
          placeholder="ID (Event ID, VenueID...)"
          onChange={e => updateFilter('id', e.target.value)}
        />
      </span>
      <span className="mr-8 input-bar" style={{ width: 200 }}>
        <Input placeholder="Message Topic" onChange={e => updateFilter('topic', e.target.value)} />
      </span>
      <span className="mr-8 input-bar" style={{ width: 200 }}>
        <Input placeholder="Name" onChange={e => updateFilter('name', e.target.value)} />
      </span>
      <span className="mr-8 input-bar">
        <NativeDatePicker
          isClearable={true}
          label="From"
          onDateChange={date => updateFilter('fromDate', date ? isoDate(date) : '')}
        />
      </span>
      <span className="mr-8 input-bar">
        <NativeDatePicker
          isClearable={true}
          label="To"
          onDateChange={date => updateFilter('toDate', date ? isoDate(date) : '')}
        />
      </span>
      <span>
        <Button
          className="bg-blue-dark py-1 text-white px-4"
          onClick={() => onFiltersChange(filters)}
        >
          Search
        </Button>
      </span>
    </div>
  );
};
